import { Space, Col, Row, Icon, Field, CellGroup, Sticky } from "vant";
import { CONSTANTS } from "@/helpers/constants";
import { mapState } from "vuex";
import {
  formatPhoneNumberWith855 as fmtWith855,
  formatPhoneNumberWith0,
} from "@/ultis/numberFormat";

export default {
  name: "TV360PaymentSuccess",
  components: {
    [Space.name]: Space,
    [Col.name]: Col,
    [Row.name]: Row,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Sticky.name]: Sticky,
  },
  data() {
    return {
      message: null,
      data: null,
    };
  },
  computed: {
    ...mapState("routerStore", ["tv360PaymentResult"]),
  },
  created() {
    // Get data from store instead of query params
    this.data = this.tv360PaymentResult || {};
  },
  mounted() {},
  methods: {
    color_primary() {
      return CONSTANTS.color_primary;
    },
    // expose function expected by template to avoid runtime error
    formatPhoneNumberWith855(phoneNumber) {
      return formatPhoneNumberWith0(phoneNumber);
    },

    goHome() {
      this.$router.replace("/home?tab=tabTV360");
    },
    fixedPrice(price) {
      if (price) {
        let priceNumber = parseFloat(price);
        return priceNumber.toFixed(2);
      }
      return price;
    },
    parseFullDes(fullDes) {
      if (!fullDes) return [];
      // fullDes can be passed as comma-separated string or JSON array string
      try {
        if (typeof fullDes === "string") {
          // Try to parse as JSON array first
          if (fullDes.startsWith("[")) {
            return JSON.parse(fullDes);
          }
          // Otherwise split by comma or newline
          return fullDes
            .split(/[,\n]/)
            .map((b) => b.trim())
            .filter((b) => b);
        }
        return fullDes;
      } catch (e) {
        return fullDes
          .split(/[,\n]/)
          .map((b) => b.trim())
          .filter((b) => b);
      }
    },
    isHtmlContent(content) {
      if (!content) return false;
      // Check if content contains HTML tags
      return typeof content === "string" && /<[a-z][\s\S]*>/i.test(content);
    },
  },
  beforeUnmount() {},
};
